// Mock data for Familias 360 Landing Page

export const mockData = {
  hero: {
    title: "Cuando las decisiones empiezan a importar…",
    subtitle: [
      "El talento entrena.",
      "El club compite.",
      "El entorno opina.",
      "",
      "Pero la familia decide."
    ],
    description: "Si tu hijo o hija ya compite en serio y sientes que cada decisión pesa más que antes…",
    highlight: "Familias 360 te da estructura, claridad y dirección.",
    cta: "Quiero decidir con serenidad",
    whatsappNumber: "+34665497561",
    whatsappMessage: "Hola, quiero más información sobre Familias 360"
  },

  realMoment: {
    title: "El Momento Real",
    description: "Hay un punto en la carrera de un joven futbolista donde el fútbol deja de ser solo juego.",
    challenges: [
      "Comparaciones",
      "Suplencias difíciles",
      "Invitaciones y promesas",
      "Opiniones externas",
      "Presión invisible"
    ],
    conclusion: [
      "Y nadie te ha enseñado cómo decidir dentro de este entorno.",
      "No necesitas hacer más.",
      "Necesitas pensar mejor."
    ]
  },

  silentProblem: {
    title: "El Problema Silencioso",
    intro: "La mayoría de las carreras no se rompen por falta de talento.",
    subtitle: "Se desordenan por decisiones mal gestionadas en momentos clave.",
    problems: [
      "Cambiar de club en caliente.",
      "Firmar representación demasiado pronto.",
      "Reaccionar emocionalmente a una suplencia.",
      "Perseguir oportunidades sin contexto.",
      "No tener un plan anual claro."
    ],
    conclusion: [
      "La intención es buena.",
      "Pero la estructura falta."
    ]
  },

  transformation: {
    title: "La Transformación",
    intro: "Familias 360 es un programa diseñado para que puedas decir:",
    benefits: [
      "Sé cómo decidir",
      "Entiendo el sistema",
      "No reacciono, intervengo",
      "Evalúo proceso, no solo resultados",
      "Tengo un plan claro de 12 meses"
    ],
    conclusion: "Al terminar, tendrás algo que muchas familias no tienen:",
    highlight: "Dirección."
  },

  modules: [
    {
      number: "01",
      title: "Entender",
      description: "Comprender el momento competitivo y el ecosistema real.",
      color: "#3B82F6"
    },
    {
      number: "02",
      title: "Posicionarse",
      description: "Ubicar tu rol dentro del sistema con serenidad.",
      color: "#8B5CF6"
    },
    {
      number: "03",
      title: "Decidir",
      description: "Cambio de club, agentes y oportunidades con criterio.",
      color: "#EF4444"
    },
    {
      number: "04",
      title: "Comunicar",
      description: "Conversaciones que sostienen el proceso sin presión.",
      color: "#F59E0B"
    },
    {
      number: "05",
      title: "Evaluar",
      description: "Medir progreso sin obsesionarse con el resultado.",
      color: "#10B981"
    },
    {
      number: "06",
      title: "Planificar",
      description: "Construir la Hoja de Ruta Familiar 360 para los próximos 12 meses.",
      color: "#6366F1"
    }
  ],

  programIncludes: [
    "Curso completo grabado",
    "Documentos estratégicos descargables",
    "Modelos de decisión",
    "Plantillas prácticas",
    "1–2 encuentros estratégicos en vivo",
    "Acceso durante 12 meses",
    "Certificación final"
  ],

  founder: {
    name: "Edgar Merino",
    title: "Agente FIFA & Fundador de Agente 360",
    bio: [
      "Familias 360 es creado por Edgar Merino, fundador de Agente 360.",
      "Con años de experiencia dentro del sistema profesional, acompañando carreras en fútbol masculino y femenino de alto nivel.",
      "No es teoría.",
      "Es experiencia aplicada."
    ],
    image: "https://customer-assets.emergentagent.com/job_fa423e5e-0c4f-4528-aab8-1e0d13b85503/artifacts/jlmz4yoo_IMG_3679.heic"
  },

  targetAudience: {
    title: "Para Quién Es",
    description: "Familias que:",
    criteria: [
      "Tienen hijos compitiendo en clubes estructurados",
      "Sienten que el entorno empieza a presionar",
      "Quieren evitar decisiones impulsivas",
      "Quieren acompañar sin desordenar",
      "Quieren estructura, no promesas"
    ],
    notFor: "No es para quien busca atajos.",
    forWho: "Es para quien quiere claridad."
  },

  pricing: {
    amount: 697,
    currency: "EUR",
    currencySymbol: "€",
    equivalents: {
      USD: 750,
      CLP: 650000
    },
    benefits: [
      "Acceso inmediato",
      "Acceso durante 12 meses",
      "Encuentros estratégicos incluidos"
    ],
    cta: "Quiero formar parte de Familias 360"
  },

  closing: {
    lines: [
      "No puedes controlar el futuro.",
      "Pero puedes controlar cómo decides hoy.",
      "Cuando las decisiones empiezan a importar…",
      "Improvisar deja de ser opción."
    ]
  },

  testimonials: [
    {
      name: "Rocío Martínez",
      role: "Hermana de Jessica Martínez",
      description: "Selección de Paraguay, ex Real Madrid, Sevilla, Al Hilal, actual Badalona Women",
      quote: "Edgar ha sido como un padre para Jessica, ha estado en todos los momentos importantes y ha trabajado para que ella tenga la carrera que ha tenido, pero sobre todo siempre estuvo en los malos momentos.",
      image: null
    },
    {
      name: "Andrea Álvarez",
      role: "Futbolista Profesional",
      description: "Selección de Guatemala, Ex Eibar y Zaragoza, actual Sevilla",
      quote: "Con Edgar trabajamos desde los 14 años cuando nos vimos por primera vez y él le dijo a mis padres que trabajaríamos en conjunto para hacer realidad mis sueños. Gracias a él cumplí el sueño de jugar en Europa y en Liga F.",
      image: null
    },
    {
      name: "Alexis Bravo",
      role: "Padre de Christian Bravo",
      description: "Familia de futbolista profesional",
      quote: "Don Edgar es un guía excepcional y estamos muy felices de haber tomado la decisión de que sea el agente de nuestro hijo Christian.",
      image: null
    }
  ],

  contact: {
    whatsappNumber: "+34665497561",
    whatsappMessage: "Hola, quiero más información sobre Familias 360"
  }
};

export const images = {
  logo: "https://customer-assets.emergentagent.com/job_fa423e5e-0c4f-4528-aab8-1e0d13b85503/artifacts/px32yn9p_IMG_1338.png",
  hero: "https://images.unsplash.com/photo-1701721714187-370c56880049",
  familySupport: "https://images.unsplash.com/photo-1765372674571-afef5d3771b2",
  strategy: "https://images.unsplash.com/photo-1771308395767-dcffbe6fe3f5",
  planning: "https://images.pexels.com/photos/8973434/pexels-photo-8973434.jpeg",
  success: "https://images.pexels.com/photos/7005488/pexels-photo-7005488.jpeg",
  growth: "https://images.pexels.com/photos/29974318/pexels-photo-29974318.jpeg",
  founder: "https://customer-assets.emergentagent.com/job_fa423e5e-0c4f-4528-aab8-1e0d13b85503/artifacts/jlmz4yoo_IMG_3679.heic"
};
